import { render, staticRenderFns } from "./ConfigureWorkflow.vue?vue&type=template&id=5f8520c6&"
import script from "./ConfigureWorkflow.vue?vue&type=script&lang=ts&"
export * from "./ConfigureWorkflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports